import { ExperimentState } from 'modules/graphql';

// Used to determine whether to show Edit on Monitor page
export const BLAST_STATES_WITH_EDIT_ACTION = [
  ExperimentState.DRAFT,
  ExperimentState.READY,
  ExperimentState.RUNNING,
  ExperimentState.SENDING_TO_REMAINDER,
  ExperimentState.USER_SELECTED_WINNER,
];

export const TRIGGER_STATES_WITH_EDIT_ACTION = [
  ...BLAST_STATES_WITH_EDIT_ACTION,
  // The winner found status for trigger campaign experiments is used when the experiment
  // is in the multi-armed bandit state, during which the experiment is
  // still considered running and in the experimentation period
  ExperimentState.WINNER_FOUND,
];

// Used to determine whether to open experiment takeover or not in Experimentation Links
export const EDITABLE_EXPERIMENT_STATES = [ExperimentState.DRAFT, ExperimentState.READY];

export const STATES_WITH_DELETE_ACTION = [
  ExperimentState.DRAFT,
  ExperimentState.READY,
  ExperimentState.ERRORED,
];

export const BLAST_STATES_WITH_END_ACTION = [
  ExperimentState.RUNNING,
  ExperimentState.SENDING_TO_REMAINDER,
  ExperimentState.USER_SELECTED_WINNER,
];

export const TRIGGER_STATES_WITH_END_ACTION = [
  ...BLAST_STATES_WITH_END_ACTION,
  ExperimentState.WINNER_FOUND,
];

export const HAS_LAUNCHED_STATES = [
  ExperimentState.RUNNING,
  ExperimentState.SENDING_TO_REMAINDER,
  ExperimentState.USER_SELECTED_WINNER,
  ExperimentState.WINNER_FOUND,
  ExperimentState.FINISHED,
  ExperimentState.CANCELLED,
];

export const TRIGGER_FINISHED_STATES = [ExperimentState.FINISHED, ExperimentState.CANCELLED];

export const BLAST_FINISHED_STATES = [...TRIGGER_FINISHED_STATES, ExperimentState.WINNER_FOUND];

export const STATES_WITH_LAUNCH_ACTION = [ExperimentState.DRAFT, ExperimentState.READY];

export const BLAST_UNFINISHED_STATES = [
  ExperimentState.DRAFT,
  ExperimentState.ERRORED,
  ExperimentState.READY,
  ExperimentState.RUNNING,
  ExperimentState.SENDING_TO_REMAINDER,
  ExperimentState.USER_SELECTED_WINNER,
];

export const TRIGGER_UNFINISHED_STATES = [...BLAST_UNFINISHED_STATES, ExperimentState.WINNER_FOUND];

export const BLAST_STATE_WITH_USE_VARIANT_ACTION = [
  ExperimentState.DRAFT,
  ExperimentState.READY,
  ExperimentState.RUNNING,
  ExperimentState.SENDING_TO_REMAINDER,
  ExperimentState.USER_SELECTED_WINNER,
];

export const TRIGGER_STATE_WITH_USE_VARIANT_ACTION = [
  ...BLAST_STATE_WITH_USE_VARIANT_ACTION,
  ExperimentState.WINNER_FOUND,
];

export const STATE_WITH_EMPTY_DETAILS_TAB = [ExperimentState.DRAFT, ExperimentState.READY];
